import { render, staticRenderFns } from "./ConfirmacionPresupuesto.vue?vue&type=template&id=07512526&scoped=true"
import script from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"
export * from "./ConfirmacionPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07512526",
  null
  
)

export default component.exports